<template>
  <div>
    <div slot="title">
      <div></div>
      <h2>Reporte de Evaluaciones</h2>
    </div>
    <div slot="main">
      <div class="container-fluid">
        <div class="row" style="margin-top:20px;">
          <div class="col-6">
            <label>Periodo de Contestación : </label>
          </div>
          <div class="col-5 padding-0">
            <label>Nombre del Evaluado : </label>
          </div>
        </div>
        <div class="row">
          <div class="col-3">
            <input type="date" name="fechaInicial" class="form-control" v-model="fechaInicial">
          </div>
          <div class="col-3">
            <input type="date" name="fechaFinal" class="form-control" v-model="fechaFinal">
          </div>
          <div class="col-4 padding-0">
            <input type="text" placeholder="Buscar.." name="search" class="form-control" v-model="nombreEvaluadoBusqueda" v-on:keyup.enter="buscarEvaluaciones">
          </div>
          <div class="col-1 padding-0">
            <button type="submit" class="form-control" @click="buscarEvaluaciones"><i class="fa fa-search"></i></button>
          </div>
        </div>
        <div class="row" style="margin-top:30px;">

          <div class="col-3">
            <select class="form-control" v-model="TipoPlazaEvaluadoIdAux">
              <option value="0">Todos (Tipo de Plaza)</option>
              <option value="1">De Confianza</option>
              <option value="2">De Base</option>
              <option value="3">Becarios</option>
            </select>
          </div>
          <div class="col-3">
            <select class="form-control" v-model="TipoContratoEvaluadoIdAux">
              <option value="0">Todos (Tipo de Contrato)</option>
              <option value="1">En Interinato</option>
              <option value="2">De Base</option>
            </select>
          </div>
          <div class="col-3">
            <select class="form-control" v-model="EntregaPresidenciaAux">
              <option value="0">Todas (Estatus de Entrega)</option>
              <option value="1">Entregadas</option>
              <option value="2">Pendientes</option>
            </select>
          </div>
          <div class="col-3">
            <input type="checkbox" v-model="MostrarGraficasAux" />
            <span>Mostrar Gráficas</span>
          </div>

        </div>
        <div class="row" style="margin-top:30px;">
          <div class="col-5"></div>
          <div class="col-3">
            <input type="button" v-if="evaluaciones.length > 0" class="form-control" @click="generarDocumentoExcel" value="Generar Reporte en Excel">
          </div>
          <div class="col-3 padding-0">
            <input type="button" v-if="evaluaciones.length > 0" class="form-control" @click="generarReporte" value="Generar Reporte">
          </div>
        </div>
        <div class="row" style="margin-top:30px;">
          <div class="col-8"></div>
          <div class="col-3 padding-0">
            <input type="button" v-if="ImpresionConcluida" class="form-control" @click="MarcarEvaluacionesEntregadas" value="Marcar Evaluaciones como Entregadas">
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <h4 v-if="evaluaciones.length > 0">Resultados ({{evaluaciones.length}})</h4>
            <hr />
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <table class="table table-striped table-light table-hover" id="tablaEvaluaciones">
              <thead class="thead-dark">
                <tr class="visible-element">
                  <th>Nombre</th>
                  <th>Resultado</th>
                  <th>Intrapersonal</th>
                  <th>InterPersonal</th>
                  <th>Desarrollo de Tareas</th>
                  <th>Entorno</th>
                  <th>Gerencia</th>
                  <th style="width: 400px;">Áreas de Oportunidad</th>
                  <th class="visible-element">Acciones</th>
                </tr>
              </thead>
              <tbody class='text-dark'>
                <template v-for='(evaluacion, indice) in evaluaciones'>
                  <tr>
                    <th>Nombre</th>
                    <th>Resultado: {{ObtenerPromedio(evaluacion.PerfilCategorias)}}</th>
                    <th>Intrapersonal: {{evaluacion.PerfilCategorias[0]}}</th>
                    <th>InterPersonal: {{evaluacion.PerfilCategorias[1]}}</th>
                    <th>Desarrollo de Tareas: {{evaluacion.PerfilCategorias[2]}}</th>
                    <th>Entorno: {{evaluacion.PerfilCategorias[3]}}</th>
                    <th v-if="evaluacion.PerfilCategorias.length > 4">Gerencia: {{evaluacion.PerfilCategorias[4]}}</th>
                    <th v-else>Gerencia N/A</th>
                    <th>Áreas de Oportunidad</th>
                    <th class="visible-element">Acciones</th>
                  </tr>
                  <tr>
                    <td><b>{{ evaluacion.nombreEvaluado }}</b> <br /> {{ evaluacion.Puesto }} <br /> {{ evaluacion.Seccion }} - {{evaluacion.Departamento}} <br /> {{evaluacion.FechaInicioPeriodoEvaluacionString}} - {{evaluacion.FechaFinPeriodoEvaluacionString}}</td>
                    <td>{{promedio(evaluacion.ResultadoCategorias)}}</td>
                    <td>
                      {{evaluacion.ResultadoCategorias[0]}} <br /> <br />
                      <i class='fa fa-check-circle' v-if="evaluacion.ResultadoCategorias[0]!= null && evaluacion.ResultadoCategorias[0] >= evaluacion.PerfilCategorias[0]" />
                      <i class='fa fa-times-circle' v-if="evaluacion.ResultadoCategorias[0]!= null && evaluacion.ResultadoCategorias[0]+1 < evaluacion.PerfilCategorias[0]" />
                    </td>
                    <td>
                      {{evaluacion.ResultadoCategorias[1]}} <br /> <br />
                      <i class='fa fa-check-circle' v-if="evaluacion.ResultadoCategorias[1]!= null && evaluacion.ResultadoCategorias[1] >= evaluacion.PerfilCategorias[1]" />
                      <i class='fa fa-times-circle' v-if="evaluacion.ResultadoCategorias[1]!= null && evaluacion.ResultadoCategorias[1]+1 < evaluacion.PerfilCategorias[1]" />
                    </td>
                    <td>
                      {{evaluacion.ResultadoCategorias[2]}} <br /> <br />
                      <i class='fa fa-check-circle' v-if="evaluacion.ResultadoCategorias[2]!= null && evaluacion.ResultadoCategorias[2] >= evaluacion.PerfilCategorias[2]" />
                      <i class='fa fa-times-circle' v-if="evaluacion.ResultadoCategorias[2]!= null && evaluacion.ResultadoCategorias[2]+1 < evaluacion.PerfilCategorias[2]" />
                    </td>
                    <td>
                      {{evaluacion.ResultadoCategorias[3]}} <br /> <br />
                      <i class='fa fa-check-circle' v-if="evaluacion.ResultadoCategorias[3]!= null && evaluacion.ResultadoCategorias[3] >= evaluacion.PerfilCategorias[3]" />
                      <i class='fa fa-times-circle' v-if="evaluacion.ResultadoCategorias[3]!= null && evaluacion.ResultadoCategorias[3]+1 < evaluacion.PerfilCategorias[3]" />
                    </td>
                    <td>
                      {{evaluacion.ResultadoCategorias[4]}} <br /> <br />
                      <i class='fa fa-check-circle' v-if="evaluacion.ResultadoCategorias[4]!= null && evaluacion.ResultadoCategorias[4] >= evaluacion.PerfilCategorias[4]" />
                      <i class='fa fa-times-circle' v-if="evaluacion.ResultadoCategorias[4]!= null && evaluacion.ResultadoCategorias[4]+1 < evaluacion.PerfilCategorias[4]" />
                    </td>
                    <td style="width: 600px;" v-html="CalcularAreasDeOportunidad(evaluacion.ResultadoCompetencias,evaluacion.PerfilCompetencias)"></td>
                    <td class="visible-element">
                      <i class='fa fa-info-circle' @click='verDetalles(evaluacion.EvaluacionId,evaluacion.SolicitudEvaluacionId)' title="Ver Detalles de Evaluación" />
                    </td>
                  </tr>
                  <tr v-if="MostrarGraficas">
                    <template v-if="windowWidth > 1400">
                      <td colspan="2"><highcharts :options="evaluacion.chartOptions" style="min-height:375px; width:600px;"></highcharts></td>
                      <td colspan="6"><highcharts :options="evaluacion.chartOptions2" style="min-height:375px; width:600px;"></highcharts></td>
                    </template>
                    <template v-else>
                      <td colspan="3"><highcharts :options="evaluacion.chartOptions" style="min-height:375px; width:600px;"></highcharts></td>
                      <td colspan="5"><highcharts :options="evaluacion.chartOptions2" style="min-height:375px; width:600px;"></highcharts></td>
                    </template>
                  </tr>
                  <tr v-if="MostrarGraficas">
                    <td colspan="1">
                      <ul v-for="evaluador in evaluacion.evaluadores">
                        <li v-if="evaluador.Observaciones != null && evaluador.Observaciones != ''">{{evaluador.Observaciones}}</li>
                      </ul>
                    </td>
                    <td colspan="7">
                      <div class="row lista-competencias">
                        <div class="col-3">
                          <p><b>1.</b>Autocontrol y estabilidad emocional</p>
                          <p><b>2.</b>Confianza y seguridad en sí mismo</p>
                          <p><b>3.</b>Resistencia a la adversidad</p>
                          <p><b>4.</b>Comunicación</p>
                          <p><b>5.</b>Establecimiento de relaciones</p>
                        </div>
                        <div class="col-3">
                          <p><b>6.</b>Negociación</p>
                          <p><b>7.</b>Trabajo en equipo</p>
                          <p><b>8.</b>Iniciativa</p>
                          <p><b>9.</b>Orientación a resultados</p>
                          <p><b>10.</b>Capacidad de análisis</p>
                        </div>
                        <div class="col-3">
                          <p><b>11.</b>Toma de decisiones</p>
                          <p><b>12.</b>Conocimiento de la institución</p>
                          <p><b>13.</b>Orientación al usuario</p>
                          <p><b>14.</b>Apertura</p>
                          <p><b>15.</b>Identificación con la institución</p>
                        </div>
                        <div class="col-3">
                          <p><b>16.</b>Dirección</p>
                          <p><b>17.</b>Liderazgo</p>
                          <p><b>18.</b>Planificación y organización</p>
                          <p><b>19.</b>Visión y Anticipación</p>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="NumeroFilasPagina > 20 && indice < evaluaciones.length -1" class="salto"></tr>
                </template>
                <tr v-if="evaluaciones.length == 0"><td colspan="8">No se encontraron evaluaciones contestadas en el periodo marcado.</td></tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import comun from '@/../static/js/comun'
  import enumeraciones from '@/../static/js/enumeraciones'
  import api from '@/../static/js/api'
  import axios from 'axios'
  import Vue from 'vue'
  import store from '@/store/index'
  import highcharts from '@/../static/js/highchart'

  export default {
    data() {
      return {
        nombreEvaluadoBusqueda: "",//Contiene en valor del nombre del evaluado para busqueda
        evaluaciones: [
        ],
        NombreCategorias: ['Intrapersonal', 'InterPersonal', 'Desarrollo de Tareas', 'Entorno', 'Gerencia'],
        NombreCompetencias: ['Autocontrol', 'Confianza y seguridad', 'Resistencia a la adversidad', 'Comunicación', 'Establecimiento de relaciones', 'Negociación', 'Trabajo en equipo', 'Iniciativa', 'Orientación a resultados', 'Capacidad de análisis', 'Toma de decisiones', 'Conocimiento de la institución', 'Orientación al usuario', 'Apertura', 'Identificación con la institución', 'Dirección', 'Liderazgo', 'Planificación y organización', 'Visión y Anticipación'],
        fechaInicial: null,
        fechaFinal: null,
        TipoPlazaEvaluadoIdAux: 0,
        TipoContratoEvaluadoIdAux: 0,
        NumeroFilasPagina: 20,
        MostrarGraficas: false,
        MostrarGraficasAux: false,
        EntregaPresidenciaAux: 0,
        ImpresionConcluida: false,
        windowWidth: window.innerWidth
      }
    },
    components: {
      highcharts
    },
    methods: {
      buscarEvaluaciones: function () { //Retorna una lista de evaluaciones pendientes en base a ciertos filtros
        //Carga la información necesaria para hacer la petición
        var peticion = {
          "esPrueba": false,
          "nombreEvaluadoBusqueda": this.nombreEvaluadoBusqueda,
          "estatusSolicitud": null,
          "fechaInicial": this.fechaInicial,
          "fechaFinal": this.fechaFinal,
          "ConResultado": true,
          "EstatusEvaluacion": 3,
          "TipoPlazaEvaluadoId": this.TipoPlazaEvaluadoId,
          "TipoContratoEvaluadoId": this.TipoContratoEvaluadoId,
          "EntregaPresidencia": this.EntregaPresidencia
        };
        this.ImpresionConcluida = false;
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SISEVA.funcion.GetEvaluaciones, peticion).then(response => {
          if (response.data.SiHayError == false) {//En caso de que la petición sea exitosa
            //console.log(response)
            $("#alertaNumeroNomina").hide();//Oculta la alerta de número de nómina no válido (filtro de busqueda)
            this.evaluaciones = response.data.evaluaciones//Carga los datos necesarios
            var evals = this.evaluaciones
            if (this.MostrarGraficasAux) {
              evals.forEach(function (evaluacion) {//Itera a través de los evaluadores asignados retornados por la petición
                evaluacion.chartOptions = {
                  chart: { renderTo: 'container', polar: true, type: 'line', backgroundColor: 'transparent' },
                  title: { text: 'Resultado de Evaluación', x: 0, style: { color: "#000" } },
                  pane: { size: '90%' },
                  xAxis: { categories: ['IntraPersonal', 'Interpersonal', 'Desarrollo de tareas', 'Entorno', 'Gerencia'], tickmarkPlacement: 'on', lineWidth: 0, labels: { style: { color: "#000" } } },
                  yAxis: { tickInterval: 1, gridLineInterpolation: 'polygon', lineWidth: 0, min: 0, max: 4, labels: { style: { color: "#000" } } },
                  tooltip: { shared: true },
                  legend: { align: 'right', verticalAlign: 'top', y: 80, layout: 'vertical', itemStyle: { color: '#000' } },
                  exporting: { buttons: { contextButton: { symbolStroke: "white", theme: { fill: "transparent" } } } },
                  series: [{ name: 'Perfil del Puesto', type: 'line', dashStyle: 'ShortDash', data: [3, 3.4, 2.5, 3.1, 3.5], pointPlacement: 'on', color: '#FF11AA', }, { name: 'Resultado', type: 'line', data: [3.5, 3, 3.2, 2.3, 4], pointPlacement: 'on', color: '#0088FF' }]
                }
                evaluacion.chartOptions2 = {
                  chart: { type: 'column', backgroundColor: 'transparent' },
                  title: { text: 'Resultado de Evaluación', style: { color: "#000" } },
                  subtitle: { text: 'Competencias', style: { color: "#000" } },
                  xAxis: { categories: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19'], crosshair: true, labels: { style: { color: "#000", fontSize: '10px' } } },
                  yAxis: { min: 0, max: 4, title: { text: 'Puntaje', style: { color: "#000" } }, labels: { style: { color: "#000" } } },
                  tooltip: { headerFormat: '<span style="font-size:10px">{point.key}</span><table>', pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' + '<td style="padding:0"><b>{point.y:.1f}</b></td></tr>', footerFormat: '</table>', shared: true, useHTML: true },
                  legend: { itemStyle: { color: '#000' } },
                  plotOptions: { column: { pointPadding: 0.2, borderWidth: 0 } },
                  exporting: { buttons: { contextButton: { symbolStroke: "white", theme: { fill: "transparent" } } } },
                  series: [{ name: 'Perfil del Puesto', data: [3.2, 2.4, 2, 1.7, 3, 3.1, 3.3, 2.7, 2, 3.1, 3, 2, 1.5, 1.4, 1.8, 3, 3.5, 2] }, { name: 'Resultado', data: [], color: '#cfcdcc' }]
                }
                if (evaluacion.PerfilCategorias[4] == null) {
                  evaluacion.chartOptions.xAxis.categories.splice(4, 1)
                  evaluacion.PerfilCategorias.splice(4, 1)
                  evaluacion.ResultadoCategorias.splice(4, 1)
                }
                evaluacion.chartOptions.series[0].data = evaluacion.PerfilCategorias
                evaluacion.chartOptions2.series[0].data = evaluacion.PerfilCompetencias
                evaluacion.chartOptions.series[1].data = evaluacion.ResultadoCategorias
                evaluacion.chartOptions2.series[1].data = evaluacion.ResultadoCompetencias
              });
            }
            this.evaluaciones = evals;
            this.NumeroFilasPagina = 20;
            if (this.MostrarGraficasAux) { this.NumeroFilasPagina += 30; this.MostrarGraficas = true; }

            this.$nextTick(() => {
              PaginarTabla('tablaEvaluaciones', this.NumeroFilasPagina)
            })
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });

      },
      anadirEvaluadores: function (idEvaluacion) {
        //Redirige a la página SISEVA/DetallesEvaluado, para modificar la evaluación que se haya seleccionado, se envia el id de evaluación como parametro
        this.$router.push({
          name: 'DetallesEvaluado',
          params: { idEvaluacion: idEvaluacion }
        })
      },
      generarReporte: function () {

        var popupWin = window.open('', '_blank', 'width=750,height=600,location=no,left=100px');
        popupWin.document.open();
        popupWin.document.write('<html><head><title>Reporte de Evaluaciones</title>');
        popupWin.document.write('<style>  tr.page-break  { display: block; page-break-after: always; }</style>');
        popupWin.document.write('<link rel="" href="/src/assets/favicon.ico">');
        popupWin.document.write('<link href="/static/css/bootstrap.min.css" rel="stylesheet">');
        popupWin.document.write('<link href="/static/css/all.min.css" rel="stylesheet">');
        popupWin.document.write('<link href="/static/css/bootstrap-table.min.css" rel="stylesheet">');
        popupWin.document.write('</head><body >')
        popupWin.document.write('<h2>Reporte de Evaluaciones</h2>')

        popupWin.document.write('<div style=" display: block; page-break-inside: avoid; position: relative;"><table class="table table-striped table-light table-hover">')
        var resultados = document.getElementById('tablaEvaluaciones').innerHTML;
        //console.log(resultados.indexOf('style="display: none; opacity: 0;"'));
        resultados = resultados.split('style="display: none; opacity: 0;"').join('style="opacity: 1; display: table-row;"');
        resultados = resultados.split('style="opacity: 0; display: none;"').join('style="opacity: 1; display: table-row;"');
        //console.log(resultados.indexOf('class="visible-element"'));
        resultados = resultados.split('class="visible-element"').join('style="display: none"');
        resultados = resultados.split('class="salto" style="opacity: 1; display: table-row;"></tr>').join('class="salto"></tr></table></div><div style=" display: block; page-break-before: always;page-break-inside: avoid; position: relative;"><table class="table table-striped table-light table-hover">');
        //resultados = resultados.split('class="hidden-element"').join('style="opacity: 1"');
        //resultados = resultados.split('</td></tr>').join('</td></tr><tr><th>Nombre</th><th>Resultado</th><th>Intrapersonal</th><th>InterPersonal</th><th>Desarrollo de Tareas</th><th>Entorno</th><th>Gerencia</th><th>Áreas de Oportunidad</th><th class="visible-element">Acciones</th></tr>');
        //resultados.split('style="display: none; opacity: 0;"').join('style="opacity: 1; display: table-row;"');
        console.log(resultados);
        popupWin.document.write(resultados);
        popupWin.document.write('</table></div>');
        popupWin.document.write('</body></html>');
        var css = '@page { size: landscape; }',
          head = popupWin.document.head || document.getElementsByTagName('head')[0],
          style = popupWin.document.createElement('style');

        style.type = 'text/css';
        style.media = 'print';

        if (style.styleSheet) {
          style.styleSheet.cssText = css;
        } else {
          style.appendChild(popupWin.document.createTextNode(css));
        }

        head.appendChild(style);
        setTimeout(function () { popupWin.print(); }, 1000)
        popupWin.document.close();
        popupWin.focus();
        this.ImpresionConcluida = true;
      },
      generarDocumentoExcel: function () {
        let informacionDelDocumento = [];
        let cabecera = {
          nombreEvaluado: "Nombre Evaluado",
          Puesto: "Puesto",
          Seccion: "Sección",
          Departamento: "Departamento",
          FechaInicioPeriodoEvaluacionString: "Fecha Incial del Periodo de Evaluación",
          FechaFinPeriodoEvaluacionString: "Fecha Final del Periodo de Evaluación",
          Promedio: "Promedio",
          Intrapersonal: "Intrapersonal",
          Interpersonal: "Interpersonal",
          DesarrolloTareas: "Desarrollo de Tareas",
          Entorno: "Entorno",
          Gerencia: "Gerencia"
        };
        this.evaluaciones.forEach(evaluacion => {
          // let areaAux = unescape(escape(persona.Seccion));
          // console.log(areaAux);

          informacionDelDocumento.push({
            nombreEvaluado: evaluacion.nombreEvaluado,
            Puesto: evaluacion.Puesto.replace(/,/g, ''),
            Seccion: evaluacion.Seccion.replace(/,/g, ''),
            Departamento: evaluacion.Departamento.replace(/,/g, ''),
            FechaInicioPeriodoEvaluacionString: evaluacion.FechaInicioPeriodoEvaluacionString,
            FechaFinPeriodoEvaluacionString: evaluacion.FechaFinPeriodoEvaluacionString,
            Promedio: this.promedio(evaluacion.ResultadoCategorias),
            Intrapersonal: evaluacion.ResultadoCategorias[0],
            Interpersonal: evaluacion.ResultadoCategorias[1],
            DesarrolloTareas: evaluacion.ResultadoCategorias[2],
            Entorno: evaluacion.ResultadoCategorias[3],
            Gerencia: evaluacion.ResultadoCategorias[4]
          });
        });

        // console.log(informacionDelDocumento);

        // Primera forma de exportar
        this.exportCSVFile(
          cabecera,
          informacionDelDocumento,
          "exportacion"
        );
      },
      exportCSVFile(headers, items, fileTitle) {
        if (headers) {
          items.unshift(headers);
        }

        // Convert Object to JSON
        var jsonObject = JSON.stringify(items);
        var csv = this.convertToCSV(jsonObject);
        var exportedFilename = fileTitle + ".csv" || "export.csv";
        csv = "\uFEFF" + csv
        var blob = new Blob([csv], { type: "data:text/csv;charset=utf-8," });
        console.log(blob)
        if (navigator.msSaveBlob) {
          // IE 10+
          navigator.msSaveBlob(blob, exportedFilename);
        } else {
          var link = document.createElement("a");
          if (link.download !== undefined) {
            // feature detection

            // Browsers that support HTML5 download attribute
            var url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", exportedFilename);
            link.style.visibility = "hidden";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        }
      },
      convertToCSV(objArray) {
        var array = typeof objArray != "object" ? JSON.parse(objArray) : objArray;
        var str = "";

        for (var i = 0; i < array.length; i++) {
          var line = "";
          for (var index in array[i]) {
            if (line != "") line += ",";
            line += array[i][index];
          }
          str += line + "\r\n";
        }
        return str;
      },
      promedio: function (resultados) {
        var x;
        var suma = 0;
        var contador = 0;
        for (x of resultados) {
          if (x != null) {
            suma += parseFloat(x);
            contador++;
          }
        }
        return Math.round((suma / contador + Number.EPSILON) * 100) / 100
      },
      CalcularAreasDeOportunidad: function (resultados, perfil) {
        var x;
        var salida = "<ul>";
        for (x in resultados) {
          if (resultados[x] != null && (parseFloat(resultados[x]) + 1 <= parseFloat(perfil[x]))) {

            salida += "<li>" + this.NombreCompetencias[x] + "</li>";
          }
        }
        salida += "</ul>"
        return salida;
      }, verDetalles: function (idEvaluacion, idSolicitud) {
        //Redirige a la página SISEVA/DetallesEvaluado, para modificar la evaluación que se haya seleccionado, se envia el id de evaluación como parametro
        this.$router.push({
          name: 'DetallesEvaluacion',
          params: { idEvaluacion: idEvaluacion, infoPersona: null }
        })
      }, EvaluadoresConComentario: function (evaluador) {
        return evaluador.filter(function (u) {
          return evaluador.Observaciones != null && evaluador.Observaciones != ""
        })
      }, ObtenerPromedio: function (PerfilCategorias) {
        var l = PerfilCategorias.length;
        var i = 0;
        var total = 0;
        for (i = 0; i < l; i++) {
          total += PerfilCategorias[i];
        }
        return Math.round((total / l + Number.EPSILON) * 100) / 100
      },
      MarcarEvaluacionesEntregadas: function () {
        var IdEvaluaciones = [];
        var ev;
        for (ev of this.evaluaciones) {
          IdEvaluaciones.push(ev.EvaluacionId);
        }
        //console.log(IdEvaluaciones);
        var peticion = {
          esPrueba: false,
          IdEvaluaciones: IdEvaluaciones
        };
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SISEVA.funcion.MarcarEvaluacionesEntregadas, peticion)
          .then(response => {
            if (response.data.SiHayError == false) {
              var boton = this.boton;
              comun.mensajeDeAlerta('Las evaluaciones han sido correctamente marcadas como entregadas a presidencia en la base de datos.', null, null);
            } else {
              console.error(response);
              comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null);
            }
            comun.SeEstaCargandoInformacion(false);
          })
          .catch(e => {
            console.error("encontre un error " + e);
            comun.mensajeDeAlerta(
              comun.mensajeDeError(enumeraciones.error.E500),
              null,
              null
            );
          });
      },
      onResize: function () {
        this.windowWidth = window.innerWidth
      }
    }, mounted: function mounted() {//Al cargarse la vista hace la busqueda de evaluaciones sin filtros
      var date = new Date();
      this.fechaInicial = new Date(date.getFullYear(), date.getMonth(), 1).toISOString().split('T')[0];
      this.fechaFinal = new Date(date.getFullYear(), date.getMonth() + 1, 0).toISOString().split('T')[0];
      this.$nextTick(() => {
        window.addEventListener('resize', this.onResize);
      })
      //this.buscarEvaluaciones()
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.onResize);
    }, computed: {
      TipoPlazaEvaluadoId: function () {
        return (this.TipoPlazaEvaluadoIdAux != 0) ? parseInt(this.TipoPlazaEvaluadoIdAux) : null;
      },
      TipoContratoEvaluadoId: function () {
        return (this.TipoContratoEvaluadoIdAux != 0) ? parseInt(this.TipoContratoEvaluadoIdAux) : null;
      },
      EntregaPresidencia: function () {
        if (this.EntregaPresidenciaAux == 0) {
          return null;
        }
        else if (this.EntregaPresidenciaAux == 1) {
          return true;
        }
        else {
          return false;
        }
      }
      // contains only Alex and James
    }

  }

</script>

<style scoped>

  .padding-0 {
    padding-right: 1px;
    padding-left: 1px;
  }

  .hidden-element {
    opacity: 0;
  }

  .visible-element {
    opacity: 1;
  }


  .page-break {
    display: block;
    page-break-after: always;
    page-break-inside: avoid;
    position: relative;
  }

  .page-nobreak {
    display: block;
    page-break-after: avoid;
  }


  .lista-competencias p {
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/SISEVA/Evaluaciones/ReporteEvaluaciones.vue